import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Scrollchor } from 'react-scrollchor';

const Swatch = (props) => {
	const swatchClass = classNames('br-4 w-100p flex flex-middle flex-center hover:elevation-md', props.className);

	return (
		<>
			<Scrollchor
				to={props.toHref ? `#${props.toHref}` : ''}
				animate={{ offset: -100, duration: 280 }}
				className='c-inherit td-none w-100p'
			>
				<div
					className={swatchClass}
					style={{
						height: props.height,
						width: props.width,
					}}
				/>
			</Scrollchor>
		</>
	);
};

Swatch.displayName = 'Swatch';

Swatch.propTypes = {
	className: PropTypes.oneOfType([PropTypes.string]),
	width: PropTypes.string,
	height: PropTypes.string,
};

Swatch.defaultProps = {
	className: '',
	width: '100%',
	height: '120px',
};

export default React.memo(Swatch);
